import { styled } from 'styled-components'

export const ChartImage = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
`
